import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  margin: 16px 0px 32px;
  min-height: 600px;
  width: 100%;
  min-width: 100%;
  flex-direction: column;
`;

export default { Wrap };
